import React from 'react';

const TIME_RANGES = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: 'year', label: 'Last Year' },
    { value: 'all', label: 'All Time' },
    { value: 'custom', label: 'Custom' }
];

/**
 * TimeRangeFilter - Segmented time range selector with clear spacing.
 */
const TimeRangeFilter = ({ value, onChange }) => {
    return (
        <div className="sd-time-range">
            <span className="sd-time-range__label">Period:</span>
            <div className="sd-time-range__options">
                {TIME_RANGES.map((range) => {
                    const isActive = value === range.value;
                    return (
                        <button
                            key={range.value}
                            onClick={() => onChange(range.value)}
                            className={`sd-time-range__button ${isActive ? 'sd-time-range__button--active' : ''}`}
                        >
                            {range.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TimeRangeFilter;
